import { createEvent, sample } from "effector";
import { setPlayerCurrentTrackIndex, setPlayerCurrentTrackSourceIndex, setPlayerTrackQueue, } from "frontend/src/domain/player-track-queue";
import { playCurrentTrackInQueueAttempted } from "frontend/src/features/play-track-from-queue";
export var playUserFilesAttempted = createEvent();
sample({
    clock: playUserFilesAttempted,
    fn: function (_a) {
        var tracks = _a.tracks;
        return ({
            type: "user_advertisement_files",
            tracks: tracks,
        });
    },
    target: setPlayerTrackQueue,
});
sample({
    clock: playUserFilesAttempted,
    fn: function () { return 0; },
    target: setPlayerCurrentTrackSourceIndex,
});
sample({
    clock: playUserFilesAttempted,
    fn: function (_a) {
        var startAtTrackIndex = _a.startAtTrackIndex;
        return startAtTrackIndex;
    },
    target: setPlayerCurrentTrackIndex,
});
sample({
    clock: playUserFilesAttempted,
    target: playCurrentTrackInQueueAttempted,
});
